import React from 'react';
import clsx from 'clsx';
import { IconLoader } from '../iconLoader';

export interface CheckIndicatorProps {
    checked: boolean;
    id?: string;
    className?: string;
    testId?: string;
}

/** Decorative checkbox box for a row that carries the checked state itself (an option or menu item). */
export const CheckIndicator: React.FC<CheckIndicatorProps> = ({ checked, id, className, testId }) => (
    <span
        id={id}
        aria-hidden="true"
        data-testid={testId}
        data-checked={checked}
        className={clsx(
            'flex h-4 w-4 shrink-0 items-center justify-center rounded border border-solid',
            checked ? 'border-system-primary bg-system-primary' : 'border-system-outline bg-system-surface-container',
            className,
        )}
    >
        {checked && (
            <IconLoader className="stroke-system-on-primary fill-system-on-primary" size="sm" iconName="IconCheck" />
        )}
    </span>
);
